<template>
  <section class="hero" >
    <!-- Content -->
    <section>
      <div class="section section-info pb-5 pt-5" style="margin-left: 60px; margin-right: 50px;">
        <h1 class="title has-text-left">Featured</h1>
        
        <div class="columns is-multiline featured-columns has-text-left mb-0 pb-0" style="padding: 20px;">
          <div class="column is-4-tablet is-4-desktop py-0 mb-6 pr-0" :style="index <= 2 ? 'border-top: 0px' : 'border-top: 1px solid #D3D3D3'" v-for="article, index in articles.slice(0, articleSize)" :key="index">
            <div :class="index <= 2 ? 'mt-0' : 'mt-6'" class="pb-6 featured-divider" style="padding-right: 40px; min-height: 300px;" :style="index % 3 === 2 || index+1 == dataLength ? 'border-right: 1px solid white' : 'border-right: 1px solid #D3D3D3'">
              <figure class="image">
                <img :src="article.attributes.image.data[0].attributes.url">
              </figure>
              <br>
              <a :href="article.attributes.link" target="_blank" class="text-link">
                {{checkSourceType(article.attributes.type)}}
                <b-icon icon="arrow-right" size="is-small"></b-icon>
              </a>
            </div>
          </div>
          <div v-if="articleSize > dataLength && (dataLength % 6 !== 3)" class="column is-hidden-mobile" style="border-top: 1px solid #D3D3D3;"></div>
        </div>

        <!-- LOAD MORE BUTTON -->
        <div class="pb-6 mt-3 mb-3" v-if="hideButton" style="position: relative;">
          <a class="text-link pr-6" @click="loadData()" style="position: inherit; color: #5C5D64 !important;">
            LOAD MORE
            <b-icon icon="chevron-down" size="is-small" style="font-size: 20px;"></b-icon>
          </a>
        </div>
      </div>
    </section>
  </section>
</template>

<script>
  import dayjs from 'dayjs';

  export default {
    data() {
      return {
        hideButton: true,
        dataLength: 0,
        articleSize: 6,
        articles: []
      };
    },
    mounted() {      
      let year = dayjs().year() - 3;
      this.$httpClientCMS({
        method: 'GET',
        url: 'api/features?populate=*&sort=date:desc&filters[date][$gte]=' + year + '-01-01'        
      })
      .then(resp => {
        let articles = resp.data.data;
        this.$set(this, 'articles', articles);
        this.dataLength = articles.length;
      })
      .catch((error) => {
        this.$router.push('maintenance');
      });
    },

    methods:{
      checkSourceType(apiType){
        if(apiType == "instagram"){
          let sourceType = "VIEW POST ON INSTAGRAM";
          return sourceType;
        }else if(apiType == "facebook"){
          let sourceType = "VIEW POST ON FACEBOOK";
          return sourceType;
        }
      },
      loadData(){
        this.articleSize += 6;
        if(this.articleSize >= this.dataLength){
          this.hideButton = false;
        }
      }
    }
  }
</script>

<style scoped lang="scss">
.column{
  padding-left: 40px;
  float: left; 
  position: relative; 
}

.text-link{
  text-decoration-line: underline;
  color: #2F469C;
  font-weight: 600;
  font-size: 14px;
  line-height: 26px;
  position: absolute; 
  bottom: 0; 
  left: 40px;
}

.title{
  color: #2F469C;
  font-size: 46px; 
  font-weight: 700;
}

.hero {
  font-family: 'Open Sans', sans-serif !important;
}

@media screen and (max-width:1290px) and (min-width: 1022px){
  .section{
    margin-left: 5px !important;
    margin-right: 0px !important;
  }
}

@media screen and (max-width:1023px) {
  .section{
    margin-left: 10px !important;
    margin-right: 0px !important;
  }

  .featured-columns{
    padding: 0px !important;
  }
  
  .title{
    margin-bottom: 3rem !important;
  }
}

@media screen and (max-width:893px){
  .section{
    margin-left: 10px !important;
    margin-right: 10px !important;
  }
}

@media screen and (max-width:768px){
  .column{
    float: none; 
    position: static; 
    width: auto !important;
    min-height: auto;
    padding-bottom: 3rem !important;
    padding-left: 20px !important;
    border-top: 0px !important;
    border-bottom: 1px solid #D3D3D3 !important;
  }

  .featured-divider{
    margin-top: 3rem !important;
    border-right: 0px !important;
    padding-bottom: 0px !important;
    min-height: auto !important;
    padding-right: 20px !important;
  }

  .text-link{
    position: static; 
    bottom: auto; 
    left: auto;
  }
}

</style>
